import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PortalAuthService } from '../auth/portal-auth.service';

export const portalAuthGuard: CanActivateFn = (_route, state) => {
  const auth = inject(PortalAuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/cliente/login']);
  }

  if (auth.mustChangePassword() && state.url !== '/cliente/account/security') {
    return router.createUrlTree(['/cliente/account/security']);
  }

  return true;
};
